/**
 *
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2017 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        https://www.sudimage.fr
 * @created     08/06/2017
 */

(() => {
    "use strict";

    let initSidebar = () => {
        if ($window.width() >= 718) {
            const $sidebarNavigation = $('.sidebar ul');
            if ($sidebarNavigation.length > 0) {
                $sidebarNavigation.css({
                    top: Math.floor($navigation.offset().top)
                });
            }
        }
    };

    if ( ! CCM_EDIT_MODE) {
        if ($window.resize()) {
            initSidebar();
        }
        initSidebar();
    }
})($navigation, $window);